import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { Incident } from '@/modules/tickets/incidents/shared/domain/incident';
import { AttachedFile } from '@/modules/tickets/incidents/shared/domain/attached-file';

class IncidentsRepository extends HttpRepository {
    private static readonly RESOURCE = 'tickets';

    async getOpenIncidents(customerId: number, ticketType: string): Promise<Incident[]> {
        return (
            await this.get(
                `${IncidentsRepository.RESOURCE}/incident-list?ticketType=${ticketType}&customerId=${customerId}`,
                this.createAuthorizationHeader(),
            )
        ).data.results;
    }

    async uploadIncidentAttachment(ticketId: number, attachment: FormData) {
        return (
            await this.post(
                `incidents-attachments/${ticketId}`,
                attachment,
                this.createAuthorizationHeader(),
            )
        ).data.results;
    }
}

const incidentsRepository = new IncidentsRepository();
export default incidentsRepository;
